// React
import React from 'react';

// Gsap animation
import { gsap } from "gsap";

// Components
import LogoMobileHeader from './components/LogoMobileHeader';

// Styles
import './style.sass';

// Images
const headerImage = require('assets/images/NewDesign/Home/header/header-bg-2.png');

class HeaderHome extends React.Component {
    constructor(props) {
        super(props);
        this.state = {}
    }

    componentDidMount = () => {
        gsap.from(".text-header", {
            duration: 2,
            opacity: 0,
        })
    }

    render(){
        const { t } = this.props;
        
        return(
            <>
            <div className="header-wrapper-home" style={{backgroundImage: `url(${headerImage})`}}>
                <div className="header-c1do1-logo-mobile">
                    <LogoMobileHeader />
                </div>
                <div className="text-header-content">
                    <p className="text-header">{t('c1do1Black.home.header.title')}</p>
                </div>
            </div>

            <div className="header-wrapper-home-mobile" style={{backgroundImage: `url(${headerImage})`}}>
                <div className="header-c1do1-logo-mobile">
                    <LogoMobileHeader />
                </div>
                <div className="text-header-content">
                    <p className="text-header">{t('c1do1Black.home.header.title')}</p>
                </div>
            </div>
            </>
        );
    }
}

export default HeaderHome;